import authAxios from "../../helpers/authAxios";
import { urls } from "../../configs/serviceConfig";
import { logException } from "../../utils/AppInsightsLogging";

export class HealthMetricService {
  constructor() {
    this._baseUrl = urls?.healthMetricService;
  }

  async logSmokedToday(userId, data = {}) {   
    const url = `${this._baseUrl}/api/smoking-logs/profile/${userId}`;

    try {
      const response = await authAxios.post(url, data, {
        withCredentials: true,
      });
      return response;
    } catch (error) {
      console.error(error);
      logException(error);
      return error.response;
    }
  }

  async getSmokingLogsForUser(userId) {
    const url = `${this._baseUrl}/api/smoking-logs/user/${userId}`;

    try {
      const res = await authAxios.get(url, {
        withCredentials: true,
      });

      if (res.statusText === "OK") {
        return res.data;
      } else {
        throw new Error(`Failed to get smoking logs with error ${res.status}: ${res.statusText}`);
      }
    } catch (error) {
      console.error(error);
      logException(error);
      return [];
    }
  }

  static get instance() {
    return healthMetricService;
  }
}

const healthMetricService = new HealthMetricService();

export default healthMetricService;
